import { useParams } from 'react-router-dom';

import useSegments from '../../api/useSegments';
import AcContentWrapper from '../../components/AcContentWrapper/AcContentWrapper';
import AcViewWrapper from '../../components/AcViewWrapper/AcViewWrapper';
import DataTable from '../../components/DataTable/DataTable';
import FirstActionModal from '../../components/FirstActionModal/FirstActionModal';
import PageTopBar from '../../components/Topbar/PageTopBar';

const SegmentsTable = () => {
  const { publisherId } = useParams();
  const { isLoading, data, isError } =
    useSegments(publisherId).getSegments;
  const columns = [
    {
      field: '_id',
      maxWidth: 30,
      headerName: '',
      disableReorder: true,
      flex: 1
    },
    {
      field: 'name',
      minWidth: 200,
      headerName: 'Name',
      disableReorder: true,
      flex: 1
    }
  ];
  return (
    <AcViewWrapper
      header={<PageTopBar disable={false} headline="Segments" buttons={[]} />}
    >
      <AcContentWrapper>
        <div className="list">
          {!isLoading && (data || data === '') && (
            <DataTable
              columns={columns}
              rows={
                data
                  ? data.map((segment: string, i: number) => {
                      return {
                        _id: i,
                        name: segment
                      };
                    })
                  : []
              }
              defaultHiddenFields={['_id']}
              loading={isLoading}
              error={isError}
              onNoData={
                <FirstActionModal
                  headline="No segments to display"
                  text="Please connect your segmentations"
                />
              }
            />
          )}
        </div>
      </AcContentWrapper>
    </AcViewWrapper>
  );
};

export default SegmentsTable;
